export default async function() {
	let userAuth = require('./userAuth').default;

	let user = await userAuth.getCurrentUser();
	if (!user) throw new Error('User not logged in');

	return user.uid;
}